export default __webpack_public_path__ + "static/media/101-file.8b489e3c.svg";